import React, { useState } from 'react';
import { Upload, Button, Input, message, Form, Space, Typography, Modal } from 'antd';
import { UploadOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { workflowAPI } from '../services/api';

const { Text } = Typography;
const { confirm } = Modal;

const WorkflowUploader = ({ onUploadSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  
  // 文件上传前检查
  const beforeUpload = (file) => {
    const isJSON = file.type === 'application/json';
    if (!isJSON) {
      message.error('只能上传JSON文件!');
    }
    return false; // 阻止自动上传
  };

  // 执行上传操作
  const performUpload = async (values, overwrite = false) => {
    try {
      setLoading(true);
      
      const formData = new FormData();
      formData.append('workflow_file', values.workflow_file[0].originFileObj);
      
      if (values.workflow_name) {
        formData.append('workflow_name', values.workflow_name);
      }
      
      // 添加覆盖参数
      const url = overwrite 
        ? `/workflows/upload?overwrite=true` 
        : '/workflows/upload';
      
      const response = await workflowAPI.uploadWorkflow(formData, url);
      
      message.success(overwrite ? '工作流覆盖成功' : '工作流上传成功');
      form.resetFields();
      
      // 通知父组件上传成功
      if (onUploadSuccess) {
        onUploadSuccess(response.data);
      }
    } catch (error) {
      console.error('上传工作流失败:', error);
      
      // 检查是否是工作流已存在错误
      if (error.status === 409 && error.exists) {
        showOverwriteConfirm(values, error.workflow_num);
      } else {
        message.error('上传工作流失败: ' + (error.message || '未知错误'));
      }
    } finally {
      setLoading(false);
    }
  };

  // 显示覆盖确认对话框
  const showOverwriteConfirm = (values, workflow_num) => {
    confirm({
      title: '工作流已存在',
      icon: <ExclamationCircleOutlined />,
      content: `工作流编号 ${workflow_num} 已存在，是否要覆盖已有工作流？`,
      okText: '覆盖',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        // 用户确认覆盖
        performUpload(values, true);
      },
      onCancel() {
        // 用户取消覆盖
        message.info('已取消覆盖操作');
      },
    });
  };

  // 处理表单提交
  const handleSubmit = (values) => {
    if (!values.workflow_file) {
      message.error('请选择工作流文件');
      return;
    }
    
    // 执行上传，初始不覆盖
    performUpload(values);
  };

  // 自定义文件上传
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <Form 
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
    >
      <Form.Item
        name="workflow_name"
        label="工作流名称"
        rules={[{ required: true, message: '请输入工作流名称' }]}
      >
        <Input placeholder="请输入工作流名称" />
      </Form.Item>
      
      <Form.Item
        name="workflow_file"
        label={
          <Space>
            工作流文件
            <Text type="secondary">
              <InfoCircleOutlined /> 文件名将作为工作流编号(例如: 11.json 的编号为 11)
            </Text>
          </Space>
        }
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={[{ required: true, message: '请选择工作流文件' }]}
        extra="请上传格式为'数字.json'的文件，如 11.json、42.json 等"
      >
        <Upload 
          name="workflow_file"
          beforeUpload={beforeUpload}
          maxCount={1}
          accept=".json"
        >
          <Button icon={<UploadOutlined />}>选择工作流文件</Button>
        </Upload>
      </Form.Item>
      
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          上传工作流
        </Button>
      </Form.Item>
    </Form>
  );
};

export default WorkflowUploader; 